/* eslint-disable jsx-a11y/alt-text */
import { TeamContactFragment, TeamDetailItemFragment } from '@amf/shared/types/graphql';
import Image from '@amf/shared/components/content/Image';
import Map from '@amf/shared/components/utils/Map';
import { useTranslate } from '@tolgee/react';
import Link from 'next/link';

interface TeamContactProps {
  team: TeamDetailItemFragment;
  contact: TeamContactFragment;
  prefixes: { player: string };
  title?: string;
}

function TeamContact({ team, contact, title, prefixes }: TeamContactProps) {
  const { t } = useTranslate();
  return (
    <div className='TeamContact'>
      {title && <h2>{title}</h2>}
      <div className='TeamContact__container'>
        {team.photoUrl && (
          <div className='TeamContact__image'>
            <Image
              block={{
                type: 'image',
                data: {
                  file: {
                    url: team.photoUrl,
                    name: '',
                    size: 0,
                    extension: '',
                  },
                  caption: team.name,
                  stretched: false,
                  withBackground: false,
                  withBorder: false,
                },
              }}
            />
          </div>
        )}
        <div className='TeamContact__content'>
          {team.description && (
            <>
              <h3>{t('team.contact.description')}</h3>
              <p className='TeamContact__description'>{team.description}</p>
            </>
          )}
          <div className='TeamContact__grid'>
            <div>
              <h3>{t('team.contact.manage')}</h3>
              <div className='TeamContact__personList'>
                <Link href={`${prefixes.player}/${contact.manager.id}`}>
                  <a className='TeamContact__person'>
                    <strong>{contact.manager.fullName}</strong>
                    <small>{t('team.contact.manager')}</small>
                  </a>
                </Link>
                {contact.assistant && (
                  <Link href={`${prefixes.player}/${contact.assistant.id}`}>
                    <a className='TeamContact__person'>
                      <strong>{contact.assistant.fullName}</strong>
                      <small>{t('team.contact.assistant')}</small>
                    </a>
                  </Link>
                )}
              </div>
            </div>
            {contact.jobs.length > 0 && (
              <div>
                <h3>{t('team.contact.jobs')}</h3>
                <div className='TeamContact__personList'>
                  {contact.jobs.map(job => (
                    <Link key={job.id} href={`${prefixes.player}/${job.player.id}`}>
                      <a className='TeamContact__person'>
                        <strong>{job.player.fullName}</strong>
                        <small>{job.name}</small>
                      </a>
                    </Link>
                  ))}
                </div>
              </div>
            )}
            {contact.ground && (
              <div>
                <h3>{t('team.contact.ground')}</h3>
                <div className='TeamContact__ground'>
                  <Map
                    title={contact.ground.name}
                    lat={contact.ground.latitude}
                    lng={contact.ground.longitude}
                    zoom={16}
                    width='100%'
                    height='160px'
                  />
                  <strong>{contact.ground.name}</strong>
                  <address>{contact.ground.address}</address>
                </div>
              </div>
            )}
            {team.siteUrl && (
              <div>
                <h3>{t('team.contact.site')}</h3>
                <a
                  href={team.siteUrl}
                  target='_blank'
                  rel='noreferrer'
                  className='TeamContact__site'
                >
                  {team.siteUrl} <i className='bi bi-arrow-up-right-circle' />
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamContact;
